import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: string = "light";

export const ThemeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    changeThemeAction: (_, { payload : themeColor }: PayloadAction<string>) => {
      document.body.classList.add(themeColor)
      document.body.classList.remove(themeColor === "light" ? "dark" : "light")
      return themeColor;
    },
  },
});

export const { changeThemeAction } = ThemeSlice.actions;

export default ThemeSlice.reducer;
